import type { Message, Attachment } from '../types';

function stripAttachmentForStorage(attachment: Attachment): Attachment {
  return {
    id: attachment.id,
    name: attachment.name,
    size: attachment.size,
    type: attachment.type,
  };
}

export function sanitizeMessagesForStorage(messages: Message[]): Message[] {
  return messages.map(message => {
    if (!message.attachments || message.attachments.length === 0) {
      return { ...message };
    }
    return {
      ...message,
      attachments: message.attachments.map(stripAttachmentForStorage),
    };
  });
}
